import { settingsTypes } from '../types';
import {
    loadAllSettings
} from '../services/settings';

export const getSettingsData = () => async (dispatch) => {
    dispatch({
        type: settingsTypes.REQUEST
    });

    return loadAllSettings()
        .then((data) => {

            dispatch({
                type: settingsTypes.SUCCESS,
                data,
            });
            return data;
        })
        .catch((error) => {
            dispatch({
                type: settingsTypes.ERROR,
                error,
            });

            return error;
        });
};
